import { __assign } from "tslib";
export var unsafeWindowObjectRetrieve = function (property) {
    var prop = window[property];
    if (!prop) {
        throw new Error("Failed to find " + property + " on the window!");
    }
    return prop;
};
export var formUrlEncode = function (s) {
    return s === null ? "" : encodeURIComponent(s + "");
};
export var getSessionKey = function () {
    var clientState = unsafeWindowObjectRetrieve("clientState");
    return clientState.sessionKey;
};
export var getSessionID = function () {
    var _a;
    var clientState = unsafeWindowObjectRetrieve("clientState");
    return (_a = clientState.sessionID) !== null && _a !== void 0 ? _a : undefined;
};
export var getVersion = function () {
    var clientState = unsafeWindowObjectRetrieve("clientState");
    return clientState.version;
};
export var genConditionalParams = function (keyMap) {
    var clientState = unsafeWindowObjectRetrieve("clientState");
    var value = keyMap.reduce(function (acc, cur) {
        var _a;
        var _b = cur, csKey = _b[0], paramsKey = _b[1];
        return clientState[csKey]
            ? __assign(__assign({}, acc), (_a = {}, _a[paramsKey] = formUrlEncode(clientState[csKey]), _a)) : __assign({}, acc);
    }, {});
    return value;
};
//# sourceMappingURL=internalUtils.js.map